var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { omit } from 'lodash';
import { ELSLoggingService } from '@els/els-ui-common-react';
import { PageNamePrefixes, RoutePath } from 'constants/app.constant';
import { EXTERNAL_APP_INFO, PERFORMANCE_VIEW_ACTION } from 'constants/externalApp.constant';
import { appActions, appSelectors } from 'redux/ducks/app';
import { ServerConstants } from 'config/server.constant';
import { isStudent } from 'helpers/app.helper';
import { EVOLVE_EDUCATION_SITE, HAD_PATHS } from 'reports/had/constants/had.constant';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { HESI_NG_TARGET_PAGES } from 'reports/hesi-ng/constants/hesi-ng.constant';
import { fetchDataBackToExternalApp, fetchSessionDataFromExternalApp } from 'services/app-linking.service';
import { windowLocationAssignWrapper } from 'services/method-wrapper.service';
var mapStateToProps = function (state) { return ({
    xLinkId: appSelectors.getLinkId(state),
    isBackToPreviousAppIconShown: appSelectors.getIsBackToPreviousAppIconShown(state),
    redirectUrl: appSelectors.getRedirectUrl(state),
    appLinkNavigationInfo: appSelectors.getAppLinkNavigationInfo(state),
    breadcrumbBackTitle: appSelectors.getBreadcrumbBackTitle(state),
    loggedInUser: appSelectors.getLoggedInUser(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    setAppLoading: function (loading) { return dispatch(appActions.setAppLoading(loading)); },
    setRedirectUrl: function (redirectUrl) { return dispatch(appActions.setRedirectUrl(redirectUrl)); }
}); };
export default (function (WrappedComponent) {
    var LoadDataHOC = function (props) {
        var reactHistory = useHistory();
        var handleBackPreviousAppIconClick = function () { return __awaiter(void 0, void 0, Promise, function () {
            var setAppLoading, setRedirectUrl, xLinkId, redirectUrl, appLinkNavigationInfo, breadcrumbBackTitle, loggedInUser, onRedirectToOutsideApp, _a, srcApp, targetApp, action, outPostBody, _b, PERFORMANCE, HESI_NG, EVOLVE, EAQ, SHERPATH, isStudentRole, backToHesiBody, _c, keptXLinkId, keptTargetApp, isBackToEaqOrSherpath, keptSession, keptLinkSrcApp, sourceHomeResponse, sourceHomeRedirectUrl, lastVisitedApp, forwardData, shadowHealthAppUrl, response, redirectUrlBackToExternalApp, error_1;
            var _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        setAppLoading = props.setAppLoading, setRedirectUrl = props.setRedirectUrl, xLinkId = props.xLinkId, redirectUrl = props.redirectUrl, appLinkNavigationInfo = props.appLinkNavigationInfo, breadcrumbBackTitle = props.breadcrumbBackTitle, loggedInUser = props.loggedInUser, onRedirectToOutsideApp = props.onRedirectToOutsideApp;
                        setAppLoading(true);
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 21, 22, 23]);
                        _a = appLinkNavigationInfo || {}, srcApp = _a.srcApp, targetApp = _a.targetApp, action = _a.action, outPostBody = _a.outPostBody;
                        _b = EXTERNAL_APP_INFO.APP_LINKING, PERFORMANCE = _b.PERFORMANCE, HESI_NG = _b.HESI_NG, EVOLVE = _b.EVOLVE, EAQ = _b.EAQ, SHERPATH = _b.SHERPATH;
                        // Evolve has no app-link return round trip — Dean users return to the Evolve education site
                        // via a direct redirect (mirrors the Shadow Health dashboard case below).
                        if (breadcrumbBackTitle === EVOLVE.backTitle) {
                            windowLocationAssignWrapper(EVOLVE_EDUCATION_SITE);
                            return [2 /*return*/];
                        }
                        if (!(breadcrumbBackTitle === PageNamePrefixes.hesi)) return [3 /*break*/, 5];
                        if (!!onRedirectToOutsideApp) return [3 /*break*/, 3];
                        ELSLoggingService.warn('withAppLinkingBackToPreviousApp', 'HESI back navigation requires withRedirectToOutsideApp HOC to be composed');
                        return [4 /*yield*/, setAppLoading(false)];
                    case 2:
                        _f.sent();
                        return [2 /*return*/];
                    case 3:
                        isStudentRole = isStudent(loggedInUser);
                        backToHesiBody = __assign({ isReturnEnabled: true, sourceApp: PERFORMANCE.APP_NAME, targetPage: isStudentRole ? HESI_NG_TARGET_PAGES.HESI_STUDENT_HOME : HESI_NG_TARGET_PAGES.HESI_INSTRUCTOR_HOME }, (isStudentRole ? { userId: (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.userId) || (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.id) } : {}));
                        return [4 /*yield*/, onRedirectToOutsideApp({ appName: HESI_NG.APP_NAME, action: HESI_NG.ACTION.LAUNCH }, { data: backToHesiBody })];
                    case 4:
                        _f.sent();
                        return [2 /*return*/];
                    case 5:
                        _c = outPostBody || {}, keptXLinkId = _c.keptXLinkId, keptTargetApp = _c.keptTargetApp;
                        isBackToEaqOrSherpath = breadcrumbBackTitle === EAQ.backTitle || breadcrumbBackTitle === SHERPATH.backTitle;
                        if (!(srcApp === PERFORMANCE.APP_NAME && isBackToEaqOrSherpath && keptXLinkId)) return [3 /*break*/, 9];
                        return [4 /*yield*/, fetchSessionDataFromExternalApp(keptXLinkId).catch(function (error) {
                                ELSLoggingService.warn('withAppLinkingBackToPreviousApp', "Kept-link lookup failed, falling back to forward navigation: ".concat(error === null || error === void 0 ? void 0 : error.message));
                                return null;
                            })];
                    case 6:
                        keptSession = _f.sent();
                        keptLinkSrcApp = (_d = keptSession === null || keptSession === void 0 ? void 0 : keptSession.data) === null || _d === void 0 ? void 0 : _d.srcApp;
                        if (!(keptLinkSrcApp && keptLinkSrcApp !== PERFORMANCE.APP_NAME)) return [3 /*break*/, 9];
                        return [4 /*yield*/, fetchDataBackToExternalApp(keptXLinkId).catch(function (error) {
                                ELSLoggingService.warn('withAppLinkingBackToPreviousApp', "Source-home return failed for keptXLinkId, falling back to forward navigation: ".concat(error === null || error === void 0 ? void 0 : error.message));
                                return null;
                            })];
                    case 7:
                        sourceHomeResponse = _f.sent();
                        sourceHomeRedirectUrl = (_e = sourceHomeResponse === null || sourceHomeResponse === void 0 ? void 0 : sourceHomeResponse.data) === null || _e === void 0 ? void 0 : _e.redirectUrl;
                        if (!sourceHomeRedirectUrl) return [3 /*break*/, 9];
                        setRedirectUrl(sourceHomeRedirectUrl);
                        return [4 /*yield*/, setAppLoading(false)];
                    case 8:
                        _f.sent();
                        windowLocationAssignWrapper(sourceHomeRedirectUrl);
                        return [2 /*return*/];
                    case 9:
                        lastVisitedApp = targetApp || keptTargetApp;
                        if (!((srcApp === PERFORMANCE.APP_NAME || !srcApp) && lastVisitedApp && lastVisitedApp !== PERFORMANCE.APP_NAME && onRedirectToOutsideApp)) return [3 /*break*/, 11];
                        forwardData = __assign(__assign({}, omit(outPostBody || {}, ['keptAppLinkOutPostBody', 'keptXLinkId', 'keptTargetApp', 'courseId', 'courseSectionId'])), { 
                            // Preserve the current Performance session so the return trip restores its token
                            // (matches how the app's own link-out builds its body, e.g. AssignmentSummaryTableHelper).
                            keptXLinkId: xLinkId });
                        // isIncludeLinkHash must be true so the backend mints a linkHash on the outbound link;
                        // that linkHash is what carries the token back on the return trip (otherwise login fails).
                        return [4 /*yield*/, onRedirectToOutsideApp({ appName: lastVisitedApp, action: action || PERFORMANCE_VIEW_ACTION, isIncludeLinkHash: true }, { data: forwardData })];
                    case 10:
                        // isIncludeLinkHash must be true so the backend mints a linkHash on the outbound link;
                        // that linkHash is what carries the token back on the return trip (otherwise login fails).
                        _f.sent();
                        return [2 /*return*/];
                    case 11:
                        if (!(redirectUrl !== RoutePath.reportingPortal && redirectUrl !== HAD_PATHS.dashboard)) return [3 /*break*/, 18];
                        if (redirectUrl === SH_PATHS.dashboard) {
                            shadowHealthAppUrl = ServerConstants[ServerConstants.DataSource].shadowHealthAppUrl;
                            window.location.assign(shadowHealthAppUrl);
                            return [2 /*return*/];
                        }
                        if (!!xLinkId) return [3 /*break*/, 13];
                        // No app-link id available (e.g. Sherpath direct launch) — fall back to browser history.
                        return [4 /*yield*/, setAppLoading(false)];
                    case 12:
                        // No app-link id available (e.g. Sherpath direct launch) — fall back to browser history.
                        _f.sent();
                        reactHistory.goBack();
                        return [2 /*return*/];
                    case 13:
                        if (!(srcApp === PERFORMANCE.APP_NAME)) return [3 /*break*/, 15];
                        // The return endpoint loops back to Performance for a Performance-initiated link, so use
                        // browser history instead of looping through it.
                        return [4 /*yield*/, setAppLoading(false)];
                    case 14:
                        // The return endpoint loops back to Performance for a Performance-initiated link, so use
                        // browser history instead of looping through it.
                        _f.sent();
                        reactHistory.goBack();
                        return [2 /*return*/];
                    case 15: return [4 /*yield*/, fetchDataBackToExternalApp(xLinkId)];
                    case 16:
                        response = _f.sent();
                        redirectUrlBackToExternalApp = response.data.redirectUrl;
                        setRedirectUrl(redirectUrlBackToExternalApp);
                        return [4 /*yield*/, setAppLoading(false)];
                    case 17:
                        _f.sent();
                        window.location.assign(redirectUrlBackToExternalApp);
                        return [3 /*break*/, 20];
                    case 18: return [4 /*yield*/, setAppLoading(false)];
                    case 19:
                        _f.sent();
                        reactHistory.push(redirectUrl);
                        _f.label = 20;
                    case 20: return [3 /*break*/, 23];
                    case 21:
                        error_1 = _f.sent();
                        ELSLoggingService.error('PageHeader', "Failed to fetchDataBackToExternalApp: ".concat(error_1.message));
                        return [3 /*break*/, 23];
                    case 22:
                        setAppLoading(false);
                        return [7 /*endfinally*/];
                    case 23: return [2 /*return*/];
                }
            });
        }); };
        return <WrappedComponent {...props} handleBackPreviousAppIconClick={handleBackPreviousAppIconClick}/>;
    };
    return connect(mapStateToProps, mapDispatchToProps)(LoadDataHOC);
});
